const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
const SET_LOGIN_ERROR_FALSE = 'SET_LOGIN_ERROR_FALSE';
import { cloneDeep } from 'lodash';

const initialState = false;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_LOGIN_ERROR:
			return action.payload;
		case SET_LOGIN_ERROR_FALSE:
			return false;
		default:
			return state;
	}
}

export function fireLoginError( msg ){
	return {
		type: SET_LOGIN_ERROR,
		payload: msg
	}
}

export function clearLoginError(){
	return { type: SET_LOGIN_ERROR_FALSE }
}

export function delayedClearLoginError(){
	return dispatch => {
		setTimeout( () => {
			dispatch( clearLoginError() )
		}, 5000);
	};
}




// WEBPACK FOOTER //
// ./src/modules/login_error.js